import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LocalSaveService } from './local-save-service.service';
import { AppServiceService, Data } from './app-service.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  public isLoggedIn = false;
  public redirectUrl: string;

  constructor(
    private _router: Router,
    private localSave: LocalSaveService,
    private _appService: AppServiceService,
  ) { }

  public clear(): void {
    this.localSave.delete('token');
    this.localSave.delete('OSR_TKN');
    if (this.localSave.validate('usuarioSM')) {
      this.localSave.delete('usuarioSM');
    }
    if (this.localSave.validate('usuarioPGV')) {
      this.localSave.delete('usuarioPGV');
    }
  }

  public isAuthenticated(): boolean {
    const token = this.localSave.get('OSR_TKN');
    if (!token) {
      return false;
    }
    try {
      // Decode JWT payload (second segment) and check expiration
      const payload = JSON.parse(atob(token.split('.')[1]));
      if (payload.exp && payload.exp * 1000 < Date.now()) {
        // Token expired — clean up and return false
        this.clear();
        return false;
      }
      return true;
    } catch (e) {
      // Invalid token format
      this.clear();
      return false;
    }
  }

  public login(usuario): void {
    this._appService.login(usuario).subscribe(
      result => {
        const aux: any = result;
        this.localSave.set('token', aux.TOKEN);
        this.localSave.set('usuarioSM', aux.USUARIO[0]);
        const auxrol: number = aux.USUARIO[0].ROL;
        this._appService.Data.usuario = aux.USUARIO[0];
        if (auxrol === 1) {
          this._router.navigate(['/mensajeria']);
        } else if (auxrol === 0) {
          this._router.navigate(['/admin']);
        }
      },
      error => {
        // Error handled by interceptor
      }
    );
  }

  public loginAdmin(admin): void {
    // Reserved for admin-specific login flow
  }

  public loginUser(user): void {
    // Reserved for user-specific login flow
  }

  public logout(): void {
    this.clear();
    this._router.navigate(['/login']);
  }
}
